import {useState} from 'react'
import CreditDebitForm from './CreditDebitForm';
import CreditDebitList from './CreditDebitList';

const CreditDebitNote = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);

return (
  <>
    {fromIsShown ? (
        <CreditDebitForm addForm={setFromIsShown} update={upData} />
      ) : (
        <CreditDebitList addForm={setFromIsShown} update={setUpData} />
      )}

  </>
  )
}

export default CreditDebitNote